import { PowerFunnelGatedFeatures } from '../../Analytics/constants';
import CppUpgradeLeftColumn from './CppUpgradeLeftColumn';

const LEFT_COLUMN_BY_GATED_FEATURE = {
    [PowerFunnelGatedFeatures.COLLEGE_PROSPECT_TARGET_LIST]: CppUpgradeLeftColumn,
};

export const getLeftColumnVariantFor = (gatedFeature) => LEFT_COLUMN_BY_GATED_FEATURE[gatedFeature] || null;
